import React from "react";
import styles from "./popularCategories.module.css";

const PopularCategories: React.FC = () => {
    const mainCategories = [
        { id: 1, name: "Corals", imageUrl: "/images/category-images/corals2.jpg" },
        // { id: 2, name: "Fish", imageUrl: "/images/category-images/fish.jpg" },
        { id: 3, name: "Inverts", imageUrl: "/images/category-images/inverts.jpg" },
        // { id: 4, name: "Dry Goods", imageUrl: "/images/category-images/drygood.jpg" }
    ];

    return (
        <>
            <h2 style={{ padding: "20px", fontFamily:"K2D", fontSize:"34px", backgroundColor:"black", color:"white" }} id="scrollTarget">Popular Categories</h2>

            <div className={styles.grid}>
                {mainCategories.map((cat) => (
                    <a
                        key={cat.id}
                        href={`/${cat.name}`}
                        style={{textDecoration: "none", color: "inherit"}}
                    >
                        <div className={styles.cardContainer}>
                            <div className={styles.card}>
                                <div className={styles.layers}>
                                    {Array.from({length: 10}).map((_, index) => (
                                        <div
                                            key={index}
                                            className={styles.layer}
                                            style={{
                                                backgroundImage: `url(${cat.imageUrl})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center"
                                            } as React.CSSProperties}
                                        />
                                    ))}
                                </div>

                                {/* OVERLAY */}
                                <div className={styles.cardOverlay}>
                                    <h3 className={styles.viewBtn}>{cat.name}</h3>
                                </div>
                            </div>
                        </div>
                    </a>
                ))}
            </div>
        </>
    );
};

export default PopularCategories;
